<template>
    <div class="loader_wrap">
        <div class="spinner"></div>
    </div>
</template>

<style lang="scss" scope>
.loader_wrap{
    position: absolute;
    background: rgba(0,0,0,0.5);
    width:100%;
    height: 100%;
    top:0;
    bottom: 0;
    left: 0;
    right:0;
    z-index: 999;
    overflow: hidden;
}
 .spinner {
     box-sizing: border-box;
     height: 40px;
     width: 40px;
     margin: 80px;
     border: 0px solid #fff;
     border-radius: 50%;
     box-shadow: 0 -11px 0 15px #fff inset;
     opacity: 1;
     position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
     animation: rotate 0.8s infinite linear;
     margin: auto;
     background: #f44336;
     &.otp-spinner {
         box-shadow: 0 -11px 0 15px #f44336 inset;
         border: 0px solid #f44336;
         background: #fff;
     }
 }
 
 @keyframes rotate {
     0% {
         transform: rotate(0deg);
     }
     100% {
         transform: rotate(360deg);
     }
 }

</style>

<script>
export default {

      props: [ 'isLoading' ]
    }
</script>


// WEBPACK FOOTER //
// src/components/Loader.vue